<style>
    .canvas-container {
        max-width: 100%; /* Asegura que no exceda el contenedor */
        overflow: hidden; /* Evita que se muestren desbordes */
    }

    canvas {
        width: 90%; /* Ajusta el canvas al 100% del contenedor */
        height: auto; /* Mantiene la proporción */
    }

        .active-draw {
            background-color: #ffce00;
            /* Cambia el color de fondo */
            color: white;
            /* Cambia el color del texto */
            border: 2px solid #ffa500;
            /* Añade un borde */
        }

                .active-button {
                    background-color: #00152b !important;
                    color: white !important;
                    border: 2px solid #002144 !important;
                }
</style>

<style scoped>
.custom-modal {
    position: fixed;
    top: -20px;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.custom-modal-content {
    background: white;
    padding: 20px;
    border-radius: 10px;
    text-align: center;
}

.loading-gif {
    width: 300px; /* Ajusta el tamaño del GIF */
    height: auto;
}
</style>

<template>

    <div id="page">
        <div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
        <div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
        <div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>

        <div class="page-title-small color-white bottom-30">
            <h1><i class="fa fa-arrow-left back-button"></i>Fotos del Vehículo ( OT {{ idcotizacionvehiculo
                }})</h1>
            <a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark"
                v-bind:style="userimageurl"></a>
        </div>

        <div class="content-boxed bg-gray1-dark">
            <h2 style="color: black;">Capturar Foto</h2>

            <!-- Seleccionar el ángulo -->
            <div>
                <label style="color: black;">Selecciona el ángulo a capturar:</label>
                <div style=" display: flex; justify-content: center;">
                    <label class="button-s shadow-small" :class="{
                        'bg-blue2-dark': selectedView !== 'Derecha',  
                        'active-button': selectedView === 'Derecha' }"
                        style="margin: 5px; cursor: pointer; border-radius: 5px;"
                        @click="selectView('Derecha', 'angle')" for="photoInputDerecho">
                        Costado Derecho
                    </label>
                    <input type="file" accept="image/*" id="photoInputDerecho" ref="photoInputDerecho"
                        @change="uploadPhoto" style="display: none;">

                    <label class="button-s shadow-small" :class="{
                        'bg-blue2-dark': selectedView !== 'Izquierda',  
                        'active-button': selectedView === 'Izquierda' }"
                        style="margin: 5px; cursor: pointer; border-radius: 5px;"
                        @click="selectView('Izquierda', 'angle')" for="photoInputIzquierdo">Costado
                        Izquierdo</label>
                    <input type="file" accept="image/*" id="photoInputIzquierdo" ref="photoInputIzquierdo"
                        @change="uploadPhoto" style="display: none;">

                    <label class="button-s shadow-small" :class="{ 
                        'bg-blue2-dark': selectedView !== 'Delantera',
                        'active-button': selectedView === 'Delantera' }"
                        style="margin: 5px; cursor: pointer; border-radius: 5px;"
                        @click="selectView('Delantera', 'angle')" for="photoInputDelantera">Parte
                        Delantera</label>
                    <input type="file" accept="image/*" id="photoInputDelantera" ref="photoInputDelantera"
                        @change="uploadPhoto" style="display: none;">

                    <label class="button-s shadow-small" :class="{ 
                        'bg-blue2-dark': selectedView !== 'Trasera',
                        'active-button': selectedView === 'Trasera' }"
                        style="margin: 5px; cursor: pointer; border-radius: 5px;"
                        @click="selectView('Trasera', 'angle')" for="photoInputTrasera">Parte
                        Trasera</label>
                    <input type="file" accept="image/*" id="photoInputTrasera" ref="photoInputTrasera"
                        @change="uploadPhoto" style="display: none;">

                    <label class="button-s bg-yellow2-dark" for="photoInputAditional"
                        style="margin: 5px; cursor: pointer; border-radius: 5px;">+</label>
                    <input type="file" id="photoInputAditional" :key="fileInputKey" ref="photoInput" multiple
                        accept="image/*" style="display: none;" @change="handleFileUpload">
                </div>
            </div>

            <!-- Mostrar fotos capturadas -->
            <div v-if="Object.keys(photos).length" style="margin-top: 20px;">
                <h3 style="color: black;">Fotos Capturadas:</h3>
                <div id="divFotosCapturada" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;">
                    <div id="divLado" v-for="(photo, angle) in photos" :key="angle"
                        style="display: flex; flex-direction: column; align-items: center; border: 1px solid #ccc; border-radius: 10px; overflow: hidden;">
                        <div
                            style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 5px 10px; background-color: #f5f5f5;">
                            <h4 style="color: black; margin: 0; font-size: 16px;">{{ angle }}</h4>
                            <button @click="removePhoto('angle',angle)"
                                style="background: none; border: none; color: red; font-size: 20px; cursor: pointer;">×</button>
                        </div>
                        <div style="display: flex; justify-content: center; width: 100%; padding: 10px;">
                            <img :src="photo" :alt="'Foto del vehículo (' + angle + ')'"
                                style="width: 100%; height: 150px; object-fit: cover; cursor: pointer; border-radius: 8px;"
                                @click="selectPhoto(photo, angle, 'angle')" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="Object.keys(photosExtras).length" style="margin-top: 20px;">
                <h3 style="color: black;">Fotos Adicionales:</h3>
                <div id="divFotosCapturadaExtras"
                    style="display: grid; grid-template-columns: repeat(6, 1fr); gap: 20px;">
                    <div id="divLado" v-for="(photo, angle) in photosExtras" :key="angle"
                        style="display: flex; flex-direction: column; align-items: center; border: 1px solid #ccc; border-radius: 10px; overflow: hidden;">
                        <div
                            style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 5px 10px; background-color: #f5f5f5;">
                            <h4 style="color: black; margin: 0; font-size: 16px;">{{ angle.replace('Adicional', '') }}
                            </h4>
                            <button @click="removePhoto('extra', angle)"
                                style="background: none; border: none; color: red; font-size: 20px; cursor: pointer;">×</button>
                        </div>
                        <div style="display: flex; justify-content: center; width: 100%; padding: 10px; cursor: pointer;"
                            @click="selectPhoto(photo, angle, 'extra')">
                            <!-- Cambia la imagen por un icono -->
                            <i class="fas fa-image" style="font-size: 50px; color: #ccc;"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-boxed">
                <div class="content bottom-0">
                    <div class="contact-form">
                        <form class="contactForm" id="Formsubmit">
                            <fieldset>
                                <div class="form-button">
                                    <a href="#"
                                        class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton"
                                        @click="siguiente" data-formId="dataForm">Siguiente</a>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>

            <div v-if="showEdit" ref="editDiv" style="margin-top: 20px; margin-bottom: 80px;">
                <h3 style="color: black;">Editando Foto</h3>
                <div style="display: flex; justify-content: center; margin-bottom: 10px;">
                    <!-- Cambia los valores de width y height aquí -->
                    <canvas ref="canvas" width="800" height="600"
                        style="width: 90%; height: auto; border: 1px solid black;"></canvas>
                    <img :src="selectedPhoto" alt="Foto seleccionada" style="display:none;" ref="hiddenImage"
                        @load="drawOnCanvas" />
                </div>

                <button class="button-s bg-green2-dark" :class="{ 'active-draw': activeButton === 'green' }"
                    @click="toggleDrawing('green', 'green')" style="margin: 10px; cursor: pointer; border-radius: 5px;">
                    <i class="fas fa-pencil-alt" aria-hidden="true"></i> Leve
                </button>

                <button class="button-s bg-yellow2-dark" :class="{ 'active-draw': activeButton === 'yellow'}"
                    @click="toggleDrawing('yellow', 'yellow')"
                    style="margin: 10px; cursor: pointer; border-radius: 5px;">
                    <i class="fas fa-pencil-alt" aria-hidden="true"></i> Medio
                </button>

                <button class="button-s bg-red2-dark" :class="{ 'active-draw': activeButton === 'red'}"
                    @click="toggleDrawing('red', 'red')" style="margin: 10px; cursor: pointer; border-radius: 5px;">
                    <i class="fas fa-pencil-alt" aria-hidden="true"></i> Grave
                </button>

                <button class="button-s bg-gray2-dark" @click="clearLastStroke"
                    style="margin: 10px; cursor: pointer; border-radius: 5px;">
                    <i class="fas fa-undo" aria-hidden="true"></i>
                </button>

                <button class="button-s bg-blue2-dark" @click="saveEditedPhoto"
                    style="margin: 10px; cursor: pointer; border-radius: 5px;">
                    <i class="fas fa-check" aria-hidden="true"></i> Listo
                </button>

                <button class="button-s bg-black" @click="clearSelection"
                    style="margin: 10px; color: white; cursor: pointer; border-radius: 5px;">
                    <i class="fas fa-times" aria-hidden="true"></i> Cancelar
                </button>
            </div>

        </div>

        <div v-if="loading" class="custom-modal">
            <div class="custom-modal-content">
                <div class="spinner-border text-primary" role="status" style="width: 100%; text-align: center; display: flex; justify-content: center;">
                    <img src="./../../assets/images/esperando.gif" alt="Cargando..." class="loading-gif">
                    <!-- <span class="visually-hidden">Cargando...</span> -->
                </div>
                <p>Subiendo imágenes, por favor espere...</p>
            </div>
        </div>
    </div>

</template>

<script>

import * as db from "./../../database.js";
import * as validate from "./../../validate.js";

export default {
    data() {
        return {
            params: '{"valkey":"' + localStorage.getItem('idcotizacionvehiculo') + '","tablename":"T_VEH_COTIZACIONVEHICULO","entity":"8","classifications":"39,40"}',
            idcotizacionvehiculo: 0,
            idagenda: 0,
            currentView: 'Derecha',  // Vista inicial predeterminada
            currentExtraView: null,
            photos: {},
            photosExtras: {},
            extraPhotoCounter: 1,
            fileInputKey: Date.now(),
            stream: null,
            showEdit: false,
            selectedPhoto: '',
            drawing: false,
            context: null,
            isDrawingActive: false, // Estado para el botón de dibujo
            currentColor: 'red',
            activeButton: null,
            strokes: [],
            PhotoSelected: null,
            selectedView: '',
            loading: false,
        }
    },

    created() {
        this.userimageurl = "background-image:url(" + db.getServerHTTP() + JSON.parse(localStorage.getItem('user')).imageurl + ")"
        this.idcotizacionvehiculo = localStorage.getItem('idcotizacionvehiculo');
        this.idagenda = localStorage.getItem('idagenda');

        const strParams = JSON.stringify({ idcotizacionvehiculo: this.idcotizacionvehiculo });
    },

    methods: {
        // Método para seleccionar el ángulo
        selectView(view, type) {
            if (type === 'angle') {
                this.currentView = view;
                this.currentExtraView = null; // Asegúrate de limpiar el otro tipo
            } else if (type === 'extra') {
                this.currentExtraView = view;
                this.currentView = null; // Asegúrate de limpiar el otro tipo
            }

            this.selectedView = this.selectedView === view ? null : view;
        },
        handleFileUpload(event) {
            const files = event.target.files;

            // Verificar si ya se alcanzó el límite de 6 fotos adicionales
            const existingPhotosCount = Object.keys(this.photosExtras).length;
            const newPhotosCount = files.length;

            if (existingPhotosCount >= 6) {
                alert("Ya alcanzaste el límite de 6 fotos adicionales.");
                return;
            }

            const maxPhotosToAdd = Math.min(6 - existingPhotosCount, newPhotosCount);

            if (!files.length) return;

             // Procesar solo las fotos que se pueden agregar dentro del límite
            Array.from(files).slice(0, maxPhotosToAdd).forEach((file) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const photo = e.target.result;

                    // Generar el nombre de la foto adicional como Extra1, Extra2, etc.
                    const extraPhotoName = `Adicional${this.extraPhotoCounter}`;
                    this.$set(this.photosExtras, extraPhotoName, photo);

                    // Incrementar el contador para la próxima foto adicional
                    this.extraPhotoCounter++;
                };
                reader.readAsDataURL(file);
            });

            // Limpiar el input después de la carga
            event.target.value = null;
        },
        // Método para subir una foto desde el dispositivo
        uploadPhoto(event) {
            const file = event.target.files[0];
            
            if (!file) {
                this.selectedView = null;
                alert("No se seleccionó ninguna imagen.");
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                const photo = e.target.result;

                // Si hay un ángulo seleccionado, almacena directamente la foto
                if (this.currentView) {
                    this.$set(this.photos, this.currentView, photo);
                } else {
                    // Si no hay un ángulo seleccionado, guarda la foto temporalmente
                    this.tempPhoto = photo;
                    alert("Selecciona un ángulo para asignar la imagen.");
                }

                // Restablecer el valor del input
                event.target.value = "";
                this.selectedView = null;
            };

            reader.readAsDataURL(file);
            
        },
        selectAngle(angle) {
            this.currentView = angle;

            // Si hay una foto en tempPhoto, la asigna al ángulo seleccionado
            if (this.tempPhoto) {
                this.$set(this.photos, angle, this.tempPhoto);
                this.tempPhoto = null; // Limpia la variable temporal después de asignarla
            }
        },
        removePhoto(type, key) {
            // Determinar el objeto de fotos a modificar según el tipo
            const photoCollection = type === 'angle' ? this.photos : this.photosExtras;
            const currentViewProperty = type === 'angle' ? 'currentView' : 'currentExtraView';

            // Verificar que la propiedad exista en la colección de fotos
            if (photoCollection.hasOwnProperty(key)) {

                this.$delete(photoCollection, key);

                if(photoCollection === this.photos)
                {
                    this[currentViewProperty] = key;

                    if(key === this.PhotoSelected){
                        this.clearSelection();
                    }
                }
                else
                {
                    this.fileInputKey = Date.now();
                    this[currentViewProperty] = null;

                    // Reordenar los nombres de las fotos extras
                    const updatedPhotosExtras = {};
                    let index = 1;

                    // Recorre las fotos actuales y asigna un nuevo nombre de forma secuencial
                    for (const photoKey in this.photosExtras) {
                        updatedPhotosExtras[`Adicional${index}`] = this.photosExtras[photoKey];
                        index++;
                    }

                    // Reemplaza las fotos extras con el nuevo objeto reordenado
                    this.photosExtras = updatedPhotosExtras;
                    this.extraPhotoCounter = index;

                    this.clearSelection();
                }
                
            }
        },
        // Método para detener el stream de la cámara cuando no se usa
        stopCamera() {
            if (this.stream) {
                this.stream.getTracks().forEach(track => track.stop());
                this.stream = null;
            }
        },
        // Método para seleccionar una foto para editar
        selectPhoto(photo, key, type) {

            const photoCollection = type === 'angle' ? this.photos : this.photosExtras;
            const currentViewProperty = type === 'angle' ? 'currentView' : 'currentExtraView';

            if (photoCollection.hasOwnProperty(key)) 
            {
                this.selectedPhoto = photo;
                this.showEdit = true; // Mostrar el editor

                this[currentViewProperty] = key;

                // Desplazarse al div de edición
                this.$nextTick(() => {
                    const editDiv = this.$refs.editDiv;
                    if (editDiv) {
                        editDiv.scrollIntoView({ behavior: 'smooth' }); 
                    }
                });

                this.PhotoSelected = key;
                this.strokes = [];
            }
        },
        drawOnCanvas() {
            const canvas = this.$refs.canvas;
            this.context = canvas.getContext('2d');
            const img = this.$refs.hiddenImage;

            // Dibuja la imagen sobre el canvas al cargarla
            this.context.drawImage(img, 0, 0, canvas.width, canvas.height);
        },
        toggleDrawing(color, button) {
            this.drawing = false;

            const canvas = this.$refs.canvas;
            if (!this.drawing) {
                // Activar modo de dibujo: añadir eventos de mouse y táctiles
                canvas.addEventListener('mousedown', this.startDrawing);
                canvas.addEventListener('mousemove', this.draw);
                canvas.addEventListener('mouseup', this.stopDrawing);
                canvas.addEventListener('mouseleave', this.stopDrawing);
                canvas.addEventListener('touchstart', this.startDrawing);
                canvas.addEventListener('touchmove', this.draw);
                canvas.addEventListener('touchend', this.stopDrawing);
            } else {
                // Desactivar modo de dibujo: eliminar eventos de mouse y táctiles
                canvas.removeEventListener('mousedown', this.startDrawing);
                canvas.removeEventListener('mousemove', this.draw);
                canvas.removeEventListener('mouseup', this.stopDrawing);
                canvas.removeEventListener('mouseleave', this.stopDrawing);
                canvas.removeEventListener('touchstart', this.startDrawing);
                canvas.removeEventListener('touchmove', this.draw);
                canvas.removeEventListener('touchend', this.stopDrawing);
            }
            this.drawing = !this.drawing;
            this.isDrawingActive = !this.isDrawingActive;

            // Establece el color actual según el botón que se presionó
            this.currentColor = color;
            this.activeButton = button;
        },
        startDrawing(event) {
            event.preventDefault();
            const { offsetX, offsetY } = this.getEventPosition(event);
            this.context.beginPath();
            this.context.moveTo(offsetX, offsetY);
            this.context.strokeStyle = this.currentColor; // Usa el color actual
            this.context.lineWidth = 3;

            this.strokes.push({ color: this.currentColor, points: [{ x: offsetX, y: offsetY }] });  // Guarda el trazo inicial
            this.isDrawing = true;
        },
        draw(event) {
            if (!this.isDrawing) return; // Solo dibuja si está en modo dibujo

            event.preventDefault();
            const { offsetX, offsetY } = this.getEventPosition(event);
            this.context.lineTo(offsetX, offsetY);
            this.context.stroke();

            this.strokes[this.strokes.length - 1].points.push({ x: offsetX, y: offsetY }); // Guarda el punto final del trazo
        },
        stopDrawing() {
            if (this.isDrawing) {
                this.context.closePath();
                this.isDrawing = false; // Finaliza el estado de trazado
            }
        },
        getEventPosition(event) {
            const rect = this.$refs.canvas.getBoundingClientRect();
            const scaleX = this.$refs.canvas.width / rect.width;
            const scaleY = this.$refs.canvas.height / rect.height;

            if (event.touches && event.touches.length > 0) {
                const touch = event.touches[0];
                return {
                    offsetX: (touch.clientX - rect.left) * scaleX,
                    offsetY: (touch.clientY - rect.top) * scaleY,
                };
            } else {
                return {
                    offsetX: (event.offsetX || event.clientX - rect.left) * scaleX,
                    offsetY: (event.offsetY || event.clientY - rect.top) * scaleY,
                };
            }
        },
        clearSelection() {
            this.showEdit = false;
            this.isDrawing = false;
            this.context.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
            this.toggleDrawing(); // Desactiva el modo de dibujo si estaba activado
        },
        clearLastStroke() {
            this.strokes.pop(); // Elimina el último trazo
            this.redrawCanvas(); // Redibuja el canvas con los trazos restantes
        },
        redrawCanvas() {
            const canvas = this.$refs.canvas;
            const context = canvas.getContext('2d');
            const img = this.$refs.hiddenImage;

            // Limpia el canvas
            context.clearRect(0, 0, canvas.width, canvas.height);

            // Redibuja la imagen base
            context.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Redibuja todos los trazos almacenados con su color original
            this.strokes.forEach(stroke => {
                context.beginPath();
                context.strokeStyle = stroke.color;
                context.lineWidth = 3;
                context.moveTo(stroke.points[0].x, stroke.points[0].y);
                for (let i = 1; i < stroke.points.length; i++) {
                    context.lineTo(stroke.points[i].x, stroke.points[i].y);
                }
                context.stroke();
            });
        },
        saveEditedPhoto() {
            let photoKey = null;
            let photoCollection = null;

            if(this.PhotoSelected && this.PhotoSelected.includes('Adicional'))
            {
                photoKey = this.currentExtraView;
                photoCollection = this.photosExtras;
            }
            else{
                photoKey = this.currentView;
                photoCollection = this.photos
            }

            if (!photoKey) {
                console.warn("No se seleccionó ninguna foto para guardar.");
                return;
            }

            // Convierte el canvas a una imagen en base64
            const editedPhoto = this.$refs.canvas.toDataURL("image/png");

            // Guarda la foto editada en la colección correcta
            this.$set(photoCollection, photoKey, editedPhoto);

            // Oculta el editor y limpia el canvas
            this.clearSelection();

            // Opcional: muestra un mensaje de éxito o realiza otras acciones
            alert("La foto editada ha sido guardada con éxito.");
        },
        // siguiente() {

        //     this.loading = true; // Activar el cargando

        //     const photosBlobs = {};

        //     Object.entries(this.photos).forEach(([angle, photoUrl]) => {
        //         console.log(photoUrl);
        //         const byteString = atob(photoUrl.split(',')[1]); // Separar el encabezado "data:image/jpeg;base64,"
        //         const mimeString = photoUrl.split(',')[0].split(':')[1].split(';')[0]; // Obtener el tipo MIME
        //         const ab = new ArrayBuffer(byteString.length);
        //         const ia = new Uint8Array(ab);

        //         for (let i = 0; i < byteString.length; i++) {
        //             ia[i] = byteString.charCodeAt(i);
        //         }

        //         // Crear el Blob para cada imagen y almacenarla en el objeto
        //         const blob = new Blob([ab], { type: mimeString });
        //         photosBlobs[angle] = blob; // Almacenar el blob en el objeto photosBlobs
        //     });

        //     Object.entries(this.photosExtras).forEach(([extraPhotoName, photoUrl]) => {
        //         const byteString = atob(photoUrl.split(',')[1]);
        //         const mimeString = photoUrl.split(',')[0].split(':')[1].split(';')[0];
        //         const ab = new ArrayBuffer(byteString.length);
        //         const ia = new Uint8Array(ab);

        //         for (let i = 0; i < byteString.length; i++) {
        //             ia[i] = byteString.charCodeAt(i);
        //         }

        //         // Crear el Blob para cada imagen y almacenarla en el objeto
        //         const blob = new Blob([ab], { type: mimeString });
        //         photosBlobs[extraPhotoName] = blob;
        //     });

        //     // Llamar a getFx2 para enviar las fotos al backend
        //     db.getFx2("ot.GuardarImagenesDelVehiculo", '{"idcotizacionvehiculo":"' + this.idcotizacionvehiculo + '"}', photosBlobs)
        //         .then(response => {
        //             console.log("Fotos enviadas con éxito:", response.data);
        //             window.location = "/Wizardot5datadetail";
        //         })
        //         .catch(error => {
        //             this.loading = false;
        //             console.error("Error al enviar fotos:", error);
        //             alert("Error al enviar fotos: " + (error.response ? JSON.stringify(error.response.data) : error.message));
        //         });
        // }
        siguiente() {
            this.loading = true; // Activar el cargando

            const photosBlobs = {};

            const compressImage = (photoUrl, angle) => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.src = photoUrl;
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        const ctx = canvas.getContext("2d");

                        // Reducir tamaño manteniendo la relación de aspecto
                        const maxWidth = 800; // Ancho máximo
                        const maxHeight = 600; // Alto máximo
                        let width = img.width;
                        let height = img.height;

                        if (width > maxWidth || height > maxHeight) {
                            const ratio = Math.min(maxWidth / width, maxHeight / height);
                            width *= ratio;
                            height *= ratio;
                        }

                        canvas.width = width;
                        canvas.height = height;
                        ctx.drawImage(img, 0, 0, width, height);

                        // Convertir a Blob con calidad reducida
                        canvas.toBlob((blob) => {
                            if (blob) {
                                resolve({ angle, blob });
                            } else {
                                reject(new Error("Error al comprimir la imagen"));
                            }
                        }, "image/jpeg", 0.7); // JPEG con 70% de calidad
                    };
                    img.onerror = (error) => reject(error);
                });
            };

            const compressAndStorePhotos = async () => {
                try {
                    // Comprimir y almacenar imágenes de `photos`
                    await Promise.all(
                        Object.entries(this.photos).map(async ([angle, photoUrl]) => {
                            const result = await compressImage(photoUrl, angle);
                            photosBlobs[result.angle] = result.blob;
                        })
                    );

                    // Comprimir y almacenar imágenes de `photosExtras`
                    await Promise.all(
                        Object.entries(this.photosExtras).map(async ([extraPhotoName, photoUrl]) => {
                            const result = await compressImage(photoUrl, extraPhotoName);
                            photosBlobs[result.angle] = result.blob;
                        })
                    );

                    // Llamar a `getFx2` para enviar las fotos comprimidas
                    return db.getFx2("ot.GuardarImagenesDelVehiculo", `{"idcotizacionvehiculo":"${this.idcotizacionvehiculo}"}`, photosBlobs);
                } catch (error) {
                    console.error("Error al comprimir imágenes:", error);
                    throw error;
                }
            };

            // Ejecutar la compresión y el envío
            compressAndStorePhotos()
                .then(response => {
                    console.log("Fotos enviadas con éxito:", response.data);
                    window.location = "/Wizardot5datadetail";
                })
                .catch(error => {
                    this.loading = false;
                    console.error("Error al enviar fotos:", error);
                    alert("Error al enviar fotos: " + (error.response ? JSON.stringify(error.response.data) : error.message));
                });
        }
    }
}
</script>